import { Box, Container, Divider, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";
import { IProductDetailProdps } from "..";
import ProductDetailsLeftTop from "./LeftTop";
import ProductDetailsRighttTop from "./RightTop";
import dynamic from "next/dynamic";
import Reviews from "./RightTop/Reviews";
import { theme } from "@Definitions/Styled/theme";
import DescriptionTabs from "./RightTop/DescriptionTabs";
const Faqs = dynamic(() => import("../Faqs/faqs"), {
  ssr: false,
});
export default function DesktopProductDetails({
  product,
}: IProductDetailProdps) {
  const smPlus = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <Container sx={{ marginTop: "5rem", marginBottom: "5rem" }}>
      <Grid container>
        <Grid item sm={6}>
          <ProductDetailsLeftTop product={product} />
        </Grid>
        <Grid item sm={6}>
          <ProductDetailsRighttTop product={product} />
        </Grid>
        <Grid item sm={12}>
          <DescriptionTabs product={product} />
          <Divider
            variant="fullWidth"
            sx={{
              margin: "0.5rem 0rem 1rem 0rem",
              width: { xs: "100%" },
              height: "1px",
              background: theme.palette.secondary.main,
            }}
          />
          <Box sx={{ marginTop: "2rem" }}>
            {product && product.aggregateRating && smPlus && (
              <Reviews
                product={product}
                productId={product._id}
                aggregateRating={product.aggregateRating}
              />
            )}
          </Box>
          <Divider
            variant="fullWidth"
            sx={{
              margin: "0.5rem 0rem 1rem 0rem",
              width: { xs: "100%" },
              height: "1px",
              background: theme.palette.secondary.main,
            }}
          />
          <Faqs product={product} />

        </Grid>
      </Grid>
    </Container>
  );
}
